import React from 'react';
import { Dropdown, Button } from "antd";
import FilterListIcon from '@mui/icons-material/FilterList';

const StatusFilter = ({ setPostFilter, isUser, isBadge, badgeTypes, isTicket }) => {
    const getItems = () => {
        if (isTicket) {
            return ["All", "Active", "Resolved"].map((item, index) => {
                return {
                    label: <Button onClick={() => { setPostFilter(index === 0 ? 0 : item) }}>{item}</Button>,
                    key: index.toString(),
                };
            });
        }

        if (isBadge) {
            return ["All", ...badgeTypes].map((item, index) => {
                return (index === 0
                    ? { label: <Button onClick={() => { setPostFilter(0) }}>All</Button>, key: index.toString(), }
                    : { label: <Button onClick={() => { setPostFilter(item?.category) }}>{item?.category}</Button>, key: index.toString(), })
            });
        }

        if (isUser) {
            return [
                { label: <Button onClick={() => { setPostFilter(0) }}>All</Button>, key: '0' },
                { label: <Button onClick={() => { setPostFilter(false) }}>Active</Button>, key: '1' },
                { label: <Button onClick={() => { setPostFilter(true) }}>Blocked</Button>, key: '2' },
            ];
        }

        return [
            { label: <Button onClick={() => { setPostFilter("") }}>All</Button>, key: '0' },
            { label: <Button onClick={() => { setPostFilter("post") }}>Post</Button>, key: '1' },
            { label: <Button onClick={() => { setPostFilter("live") }}>Live</Button>, key: '2' },
        ];
    };

    const items = getItems();

    return (<>
        {!isTicket
            ? <Dropdown
                placement={'bottom'}
                menu={{ items, }}
                trigger={['click']}
                overlayClassName={`custom-dropdown-details ${isBadge && "status-dropdown"}`}
            >
                <Button className="filter-btn" onClick={e => e.preventDefault()}>
                    <FilterListIcon />
                </Button>
            </Dropdown >
            : <Dropdown
                placement={'bottom'}
                menu={{ items, }}
                trigger={['click']}
                overlayClassName={`custom-dropdown-details ${isBadge && "status-dropdown"}`}
            >
                <Button className="ticket-filter-btn" onClick={e => e.preventDefault()}>
                    <FilterListIcon />
                </Button>
            </Dropdown >}
    </>);
};

export default StatusFilter;
